import * as React from 'react'

import { makeObservable } from 'mobx'
import { inject, observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import { Button } from '~/client/src/shared/components/Button/Button'
import DeliveryStatus from '~/client/src/shared/constants/DeliveryStatus'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import DeliveryDetailsStore from '../DeliveryDetails.store'

// translated

interface IProps {
  onCreationCb: (deliveryId: string) => void
  deliveryDetailsStore?: DeliveryDetailsStore
  buttonRenderer?: (
    btnText: string,
    isValid: boolean,
    status: DeliveryStatus,
    isDeny?: boolean,
    customBtnHandler?: () => void,
  ) => JSX.Element
  className?: string
  status?: DeliveryStatus
}

@inject('deliveryDetailsStore')
@observer
export default class DeliveryActionButtons extends React.Component<IProps> {
  public constructor(props: IProps) {
    super(props)
    makeObservable(this)
  }

  public render() {
    const {
      deliveryDetailsStore: {
        isSubmitButtonEnabled,
        isAnyDialogOpened,
        displayedDelivery,
        getStatusActions,
        areFieldsChanged,
        isFromConcreteDirect,
      },
      buttonRenderer,
      className,
      status,
    } = this.props

    const isSubmitButtonVisible =
      (!isFromConcreteDirect || areFieldsChanged) &&
      (!displayedDelivery || displayedDelivery.canChange)
    const isActionButtonShown =
      !isFromConcreteDirect || displayedDelivery?.isPending

    return (
      <div className={classList({ row: true, [className]: !!className })}>
        <div className="tw:flex tw:gap-2">
          {isSubmitButtonVisible && this.renderSubmitButton()}
          {isActionButtonShown &&
            getStatusActions(status || displayedDelivery?.status).map(
              (action, index) =>
                !action.isHidden && (
                  <React.Fragment key={`action-${index}`}>
                    {buttonRenderer(
                      action.actionTitle,
                      !action.isDisabled &&
                        !isSubmitButtonEnabled &&
                        !isAnyDialogOpened,
                      action.status,
                      action.status === DeliveryStatus.Denied,
                      action.onClick,
                    )}
                  </React.Fragment>
                ),
            )}
          {displayedDelivery && displayedDelivery.isDone && (
            <div className="text bold large center">
              {Localization.translator.done}
            </div>
          )}
          {displayedDelivery && displayedDelivery.isCanceled && (
            <div className="text bold large center">
              {Localization.translator.canceled}
            </div>
          )}
        </div>
      </div>
    )
  }

  private renderSubmitButton(): JSX.Element {
    const {
      submitTitleAndStatus,
      isSubmitButtonEnabled,
      changeDelivery,
      setNewDeliveryStatus,
      areFieldsChanged,
      isDenyButtonEnabled,
      isAnyDialogOpened,
      onButtonClick,
    } = this.props.deliveryDetailsStore

    const submitButtonAction = areFieldsChanged
      ? onButtonClick.bind(
          null,
          changeDelivery.bind(null, this.props.onCreationCb),
          submitTitleAndStatus.title,
        )
      : setNewDeliveryStatus.bind(this, DeliveryStatus.Denied)
    const isSubmitButtonDisabled = areFieldsChanged
      ? !isSubmitButtonEnabled
      : !isDenyButtonEnabled

    if (this.props.buttonRenderer) {
      return this.props.buttonRenderer(
        submitTitleAndStatus.title,
        !isSubmitButtonDisabled && !isAnyDialogOpened,
        submitTitleAndStatus.status,
        submitTitleAndStatus.status === DeliveryStatus.Denied,
        submitButtonAction,
      )
    }

    return (
      <Button
        variant={
          submitTitleAndStatus.status === DeliveryStatus.Denied
            ? 'outline'
            : 'default'
        }
        className="tw:flex-1"
        disabled={isSubmitButtonDisabled || isAnyDialogOpened}
        onClick={submitButtonAction}
      >
        {submitTitleAndStatus.title}
      </Button>
    )
  }
}
